module.exports = __webpack_public_path__ + "img/112082.1ef3ee07.png";